import React, { useState, useEffect } from "react"
import { Grid } from "@material-ui/core"
import { TextField } from "letalkui"

import BlockBodySectionEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionEditor"

import useConditionEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useConditionEditor"

import { ChatBotFlowBlockRule } from "@/protocols/chatBot"

import { getMessageReceivedCondition } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/utils/chatBotFlowBlockRule"

const OPTION_TITLE_MAX_LENGTH = 24
const OPTION_DESCRIPTION_MAX_LENGTH = 72

type MenuListItemEditorProps = {
	onSave: (chatBotFlowBlockRule: ChatBotFlowBlockRule) => void
	onDelete?: () => void
	onChangeDescription?: (description: string, savedRule: ChatBotFlowBlockRule) => void
	description?: string
	chatBotFlowBlockRule: ChatBotFlowBlockRule
	hideChildSelection?: boolean
}

const MenuListItemEditor: React.FC<MenuListItemEditorProps> = (props) => {
	const {
		onSave,
		onDelete,
		onChangeDescription,
		description,
		chatBotFlowBlockRule,
		children,
		hideChildSelection
	} = props

	const messageReceivedCondition = getMessageReceivedCondition([chatBotFlowBlockRule])
	const conditionEditor = useConditionEditor({ chatBotFlowBlockRule })

	const [descriptionValue, setDescriptionValue] = useState(description)

	useEffect(() => {
		setDescriptionValue(description)
	}, [description])

	const handleSave = () => {
		onSave(conditionEditor.rule)

		if (onChangeDescription) {
			onChangeDescription(descriptionValue, conditionEditor.rule)
		}
	}

	if (!messageReceivedCondition) {
		return null
	}

	return (
		<BlockBodySectionEditor
			title="OPÇÃO DO MENU"
			onSave={handleSave}
			onOpen={conditionEditor.reset}
			onDelete={onDelete}
			hideChildSelection={hideChildSelection}
			AsideDrawerProps={{
				children: (
					<Grid
						container
						direction="column"
						spacing={2}
					>
						<Grid
							item
						>
							<TextField
								type="text"
								label="Título"
								placeholder="Título da opção"
								value={conditionEditor.retrieveValidationValue(messageReceivedCondition.validationIndex)}
								onChange={(event) => conditionEditor.changeValidationValue(messageReceivedCondition.validationIndex, event.target.value.slice(0, OPTION_TITLE_MAX_LENGTH))}
								fullWidth
								inputProps={{ maxLength: OPTION_TITLE_MAX_LENGTH }}
							/>
						</Grid>

						<Grid
							item
						>
							<TextField
								type="text"
								label="Descrição"
								placeholder="Descrição (opcional)"
								value={descriptionValue}
								onChange={(event) => setDescriptionValue(event.target.value.slice(0, OPTION_DESCRIPTION_MAX_LENGTH))}
								fullWidth
								multiline
								minRows={2}
								inputProps={{ maxLength: OPTION_DESCRIPTION_MAX_LENGTH }}
							/>
						</Grid>
					</Grid>
				)
			}}
			DeletePopConfirmProps={{
				title: "Excluir opção",
				description: "Tem certeza? Essa ação é irreversível.",
				confirmButtonText: "EXCLUIR"
			}}
		>
			{children}
		</BlockBodySectionEditor>
	)
}

export default MenuListItemEditor
